import React, { useCallback, useMemo, useRef } from 'react'
import { useSetState } from 'ahooks'
import {
  SActionBtn,
  SLowcodeList,
  SMessage,
  STableActions,
} from 'shj-components'
import { Button, message, Upload } from 'antd'

import {
  deletedBatchByIds, generalImportBatchFile,
  generalStandardDelete,
  getGeneralPage,
  getGeneralStandardPage, getProductCommonPage,
} from '@/services/product.ts'
import { METHODS } from "@/api";
import { config } from './config.tsx'
import { AddOrEditStandard } from './modals/AddOrEditModal'
import { apiData2Table } from '@/utils/data.ts'
import { fileDownload } from '@/utils/download.ts'
import UrlConfig from '@/api/UrlConfigs.ts'
import { getEnums, httpOrgList } from '@/services/homeService.ts'
import EditTimeModal from "./modals/EditTimeModal";
import CopyModal from "./modals/CopyModal";
import LogsModal from "./modals/LogsModal";
import DebounceSearchSelect from "@/pages/baseProduct/components/DebounceSearchSelect";
export const StandardManage = ({businessId}: {businessId: string | undefined}) => {

  const listRef = useRef()

  const [state, setState] = useSetState<Record<string, any>>({
    visible: false,
    record: {},
    btnLoading: false,
    exportLoading: false,
    downloadLoading: false,
    importLoading: false,
    loading: false,
    companyList: [],
    chooseDisabled: false,
    selectedRowKeys: [],
    dataList: [],
    productId: '',
    initialCompleted: false,
    totalCount: 0,
  })

  const fetchList = ({ current, pageSize, query }) => {
    return new Promise((resolve, reject) => {
      console.log(query)
      query.orderBys = [
        {
          columnName: 'CREATED_TIME',
          asc: false,
        },
      ]
      query.searchFlag = true
      getGeneralStandardPage({
        params: { pageId: current, pageSize },
        data: {
          ...query,
          id: state.initialCompleted ? undefined : businessId,
        },
      })
        .then(res => {
          res.list = res?.list?.map((item, index) => {
            return {
              ...item,
              orderNumber: index + 1,
            }
          })
          setState({dataList: res?.list || [], totalCount: res?.count || 0})
          resolve(apiData2Table(res))
        })
        .catch(reject)
    })
  }

  const onAdd = () => onOpenModal()

  const onOpenModal = (key = 'ADD_OR_EDIT', record = {}) => {
    setState({ [key]: true, record })
  }

  const onDel = record => {
    SMessage.confirm({
      onOk: () => {
        return generalStandardDelete(record.id).then((res: any) => {
          message.success(res.message || '操作成功')
          listRef.current?.reload()
        })
      },
    })
  }
  const onImport = (upload: any) => {
    setState({ importLoading: true })
    const { file, onSuccess, onError } = upload
    const data = new FormData()
    data.append('file', file)
    return generalImportBatchFile(data)
      .then((res: any) => {
        listRef.current && listRef.current.reload()
        onSuccess && onSuccess()
        message.success(res.message || '导入成功')
      })
      .catch(onError)
      .finally(() => setState({ importLoading: false }))
  }

  const onExport = () => {
    setState({ exportLoading: true })
    const data = {
      ...listRef.current?.getSearch?.()?.getFieldsValue?.() || {},
      searchFlag: true,
      id: state.initialCompleted ? undefined : businessId,
    }
    fileDownload(UrlConfig.PlusProductWeb.GeneralStandardExport, {method: METHODS.POST, data, error: false})
      .then(() => setState({ exportLoading: false }))
      .catch(async (err) => {
        if (err instanceof Blob || Object.prototype.toString.call(err) === '[object Blob]') {
          try {
            const text = await err.text();
            const jsonData = JSON.parse(text);
            message.error(jsonData.message);
          } catch (error) {
            return err;
          }
        }
        setState({ exportLoading: false })
      })
  }
  const onDownload = () => {
    setState({ downloadLoading: true })
    fileDownload(UrlConfig.PlusProductWeb.GeneralTemplateBatchDownload)
      .then(() => setState({ downloadLoading: false }))
      .catch(() => setState({ downloadLoading: false }))
  }
  const getOptions = () => {
    return new Promise(async (resolve, reject) => {
      const companyList: any = await httpOrgList({status: undefined})
      const alertTypeEnum = await getEnums('plus-product', 'com.shj.saas.plus.product.enums.StandardWarningAlertTypeEnum')
      resolve({
        companyList: [{ name: '通用', id: '0' }, ...companyList],
        alertTypeEnum,
      })
    })
  }
  const onBatchDelete = ({ selectedRowKeys }) => {
    SMessage.confirm({
      content: `是否确认删除所选数据`,
      onOk: () => {
        return deletedBatchByIds({ data: { idList: selectedRowKeys, enabled: true } }).then(
          (res: any) => {
            message.success(res.message || '操作成功')
            listRef.current?.reload()
          }
        )
      },
    })
  }

  const onBatchChangeStartTime = () => {
    onCheckDate('start')
  }

  const onBatchChangeEndTime = () => {
    onCheckDate('end')
  }

  const onCheckDate = (editType = 'start') => {
    setState({ EDIT_DATE: true, editType })
  }

  const onBatchCopy = ({ selectedRowKeys }) => {
    setState({COPY: true, selectedRowKeys})
  }

  const allSelect = () => {
    if (state.chooseDisabled) {
      setState({chooseDisabled: false})
      listRef?.current?.clearSelectedRowKeys()
    } else {
      const ids: any = state.dataList?.map((item: any) => item.id)
      setState({chooseDisabled: true, selectedRowKeys: ids})
    }
  }

  const onLogs = (record) => {
    setState({ LOGS: true, record })
  }

  const fixedParams = useMemo(() => ({
    prodTypes: ['PRODUCT_PACKAGE'],
    enabled: undefined,
  }), []);

  const handleProductChange = useCallback((form, name, v) => {
    form.setFieldValue(name, v);
    setState({ productId: v });
  }, []);

  const query = useMemo(() =>
      state.productId ? { id: state.productId } : undefined
    , [state.productId]);

  const MemoizedDebounceSearchSelect = React.memo(DebounceSearchSelect, (prevProps, nextProps) => {
    return (
      prevProps.disabled === nextProps.disabled &&
      prevProps.value === nextProps.value &&
      JSON.stringify(prevProps.query) === JSON.stringify(nextProps.query)
    );
  });

  const productRender = useCallback(({ name, form, disabled }) => {
    return (
      <MemoizedDebounceSearchSelect
        allowClear
        label={'产品'}
        isCommon={true}
        fetchOptions={getProductCommonPage}
        fixedParams={fixedParams}
        onChange={(v) => handleProductChange(form, name, v)}
        fieldNames={{ label: 'prodName' }}
        style={{ width: '100%' }}
        query={query}
        disabled={disabled}
      />
    );
  }, [fixedParams, handleProductChange, query]);

    const generalQuery = useMemo(() =>
      state.generalId ? { id: state.generalId } : undefined
    , [state.generalId]);

  const generalRender = useCallback(({ name, form, disabled }) => {
    return (
      <MemoizedDebounceSearchSelect
          allowClear
          label={'通项'}
          // isCommon={true}
          style={{ width: '100%' }}
          onChange={v => {
            setState({generalId: v})
            form.setFieldsValue({ [name]: v })
          }}
          nameKey={'itemNameKey'}
          fixedParams={{ enabled: undefined }}
          query={generalQuery}
          fetchOptions={getGeneralPage}
          fieldNames={{ label: 'itemName', value: 'id' }}
          disabled={disabled}
        />
    );
  }, [getGeneralPage, generalQuery]);

  const extensions = {
    onSearchReset: () => { setState({initialCompleted: true})},
    request: { fetchList, getOptions },
    events: { onAdd, onBatchDelete, onBatchChangeStartTime, onBatchChangeEndTime, onBatchCopy, allSelect },
    preserveSelectedRowKeys: true,
    rowSelectedTotal: state.chooseDisabled ? state.totalCount : '',
    getCheckboxProps: () => ({
      disabled: state.chooseDisabled,
    }),
    status: {
      disabled: () => state.chooseDisabled,
    },
    selectedRowKeys: state.selectedRowKeys,
    onSelectedRowChange: (keys) => {
      setState({ selectedRowKeys: keys })
    },
    customRender: {
      actionRender(_, record: Record<string, any>) {
        return (
          <STableActions>
              <SActionBtn onClick={() => onOpenModal('ADD_OR_EDIT', record)}>编辑</SActionBtn>
              <SActionBtn onClick={() => onLogs( record)}>调整记录</SActionBtn>
              <SActionBtn danger onClick={() => onDel(record)}>
                删除
              </SActionBtn>
          </STableActions>
        )
      },
      importRender: () => {
        return (
          <Upload listType="text" customRequest={onImport} itemRender={() => null}>
            <Button
              type={'primary'}
              loading={state.importLoading}
              disabled={state.importLoading}
            >
              批量导入
            </Button>
          </Upload>
        )
      },
      exportRender: () => {
        return (
          <Button
            onClick={onExport}
            disabled={state.exportLoading}
            loading={state.exportLoading}
            type="primary"
          >
            导出
          </Button>
        )
      },
      downloadRender: () => {
        return (
          <Button
            onClick={onDownload}
            disabled={state.downloadLoading}
            loading={state.downloadLoading}
          >
            下载导入模板
          </Button>
        )
      },
      productRender,
      generalRender,
    },
  }

  const onReloadList = () => {
    listRef.current?.reload?.()
    setState({chooseDisabled:false, selectedRowKeys: []});
    listRef?.current?.clearSelectedRowKeys()
  }

  const onCloseModal = (key) => {
    setState({ [key]: false })
  }

  const getQuery = () => {
    const query = state.chooseDisabled ? { query: listRef.current?.getSearch?.()?.getFieldsValue?.() } : { ids: state.selectedRowKeys };
    if (state.chooseDisabled && !state.initialCompleted && businessId) {
      query.ids = [businessId]
    }
    return query
  }

  return (
    <div>
        <SLowcodeList
          searchMode={'group'}
          ref={listRef}
          config={{ ...config}}
          {...extensions}
        />

      {state['ADD_OR_EDIT'] && <AddOrEditStandard
        record={state.record}
        open={state['ADD_OR_EDIT']}
        onReload={listRef.current?.reload}
        onClose={() => onCloseModal('ADD_OR_EDIT')}
      />}
      {state['COPY'] && <CopyModal
          open={state['COPY']}
          query={getQuery()}
          onReload={listRef.current?.reload}
          onClose={() => onCloseModal('COPY')}
      />}
      {state['EDIT_DATE'] && <EditTimeModal
          open={state['EDIT_DATE']}
          editType={state.editType}
          record={state.record}
          query={getQuery()}
          onReload={onReloadList}
          onClose={() => onCloseModal('EDIT_DATE')}
      />}
      {state['LOGS'] && <LogsModal
          open={state['LOGS']}
          record={state.record}
          onClose={() => onCloseModal('LOGS')}
      />}
      </div>
  )
}
